import { Box, Button, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function ReportHeader({ report }) {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 2, mb: 1, display: 'flex', justifyContent: 'space-between' }}>
      <Box>
        <Typography variant="h6">{report?.name}</Typography>
        <Typography variant="body2" color="text.secondary">
          {report?.description}
        </Typography>
      </Box>
      <Button variant="outlined" onClick={() => window.history.back()}>
        {t('Back to Reports')}
      </Button>
    </Paper>
  )
}
